//button component
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, Dimensions } from 'react-native';

const width = Dimensions.get('window').width;

export default function FlatButton({ text, onPress }) {

    return (
        <TouchableOpacity style={styles.button} onPress={onPress}>
            <Text style={styles.buttonText}>{text}</Text>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    button: {
        borderRadius: 22,
        paddingVertical: 6,
        paddingHorizontal: 10,
        backgroundColor: 'limegreen',
        paddingHorizontal: 48,
        shadowColor: "green",
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 0.85,
        shadowRadius: 20,
        elevation: 12,
    },
    buttonText: {
        color: 'rgba(0,0,0,0.65)',
        fontFamily: "Baloo",
        fontWeight: '900',
        letterSpacing: -1,
        fontSize: 28,
        textAlign: 'center',
    }
})